import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Route, Routes} from "react-router-dom";

//import './css/animate.css';
//import './css/carousel.css';

import CcsHome from './home.js';
import CcsDash from './dash.js';
import CcsDay from './day.js';
import CcsPt from './stat/pt.js';
import CcsOms from './eko/oms.js';
import CcsPer from './eko/per.js';
import CcsStat from './eko/stat.js';
import CcsTrs from './eko/trs.js';
import CcsVgrp from './eko/vgrp.js';
import CcsMsg from './msg.js';
import HkaHome from "../hka/home";
import Dd_Sel from "../lib/ui/dd_sel";
import {withRouter} from "../lib/react/withRouter";

import sso from "../sso.js";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Csc extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.s1ref = React.createRef();
        this.s2ref = React.createRef();

        this.webStore = props.store;
        this.state = { pgid: 11, stat: [] };
        this.state.open = false;
        this.state.pdfopen = false;
        this.state.xxopen = false;
        this.state.pdf_uri = "";
        this.state.seldate = new Date('2020-03-24T13:11:54');
        this.state.row = null;
        this.state.info = "";
        this.state.top = 0;
        this.state.sdo = {};
        //this.state.sdo = context;
        //context.posrend = this;
        this.state.step = 1;
        this.state.pdf = 0;
        this.state.pdf_uri = "";
        this.state.mnus = ["m00", "m01", "m02", "m03", "m08", "m09"];
        this.state.mnu_sel = "m00";

        this.state.mnuitems = [
            {fkn: 'refresh', text: 'UPPDATERA'},
            {fkn: 'user_ses', text: 'MIN SESSION'},
            {fkn: 'logout', text: 'LOGGA UT'}
        ];
        
        sso.sdo.csa = [];
        this.set_csa();

    }
    componentDidMount(){
        //var sdo = sessionStorage.getItem("svp");
        //if(sdo) this.setState({sdo: JSON.parse(sdo) });
        //this.cdi_step();
    }

    componentWillUnmount(){
            this.setState({info: "UUU" });
    }

    set_csa() {
        var csa = [];
        //alert(sso.seo.csid);

        if(sso.seo.csid == "1000") {
            csa = [
                //{ id:"0", typ:"0", text: "INGET CENTRALSYSTEM"},
                { c0lopnr:"1", c0sid:"S0003201", c0text: "SYSTEM 1", c0typ: "", c0avd: "01"},
                { c0lopnr:"3", c0sid:"S0003202", c0text: "SYSTEM 2", c0typ: "", c0avd: "01"},
                //{ c0lopnr:"5", c0sid:"S0003203", c0text: "SYSTEM 3", c0typ: "", c0avd: "01"}
            ];
            //this.setState({ csa: csa });
            sso.sdo.csa = csa;
        }
        
        if(sso.seo.csid == "0011") {    // GLASSMAGASINET
            csa = [
                //{ id:"0", typ:"0", text: "INGET CENTRALSYSTEM"},
                { c0lopnr:"1", c0sid:"S0002046", c0text: "HAMNEN", c0typ: "", unit: "glassm00", c0avd: "01", c0dpa: ["01", "02"]},
                { c0lopnr:"2", c0sid:"S0002043", c0text: "HÄSTBACKEN", c0typ: "", unit: "glassm03", c0avd: "03"},
                { c0lopnr:"3", c0sid:"S0002044", c0text: "TORGET", c0typ: "", unit: "glassm04", c0avd: "04"},
            ];
            //this.setState({ csa: csa });
            sso.sdo.csa = csa;
        }
        if(sso.seo.csid == "0021") {
            csa = [
                //{ id:"0", typ:"0", text: "INGET CENTRALSYSTEM"},
                { c0lopnr:"1", c0sid:"S0004101", c0text: "LIONBAR VISBY", c0typ: "", unit: "lion0001", c0avd: "01"},
                { c0lopnr:"2", c0sid:"S0004102", c0text: "LIONBAR VASASTAN", c0typ: "", unit: "lion0002", c0avd: "01"},
                { c0lopnr:"3", c0sid:"S0004103", c0text: "LIONBAR MARIATORGET", c0typ: "", unit: "lion0003", c0avd: "01"},
                { c0lopnr:"4", c0sid:"S0004104", c0text: "LIONBAR GÖTEBORG", c0typ: "", unit: "lion0004", c0avd: "01"},
                { c0lopnr:"5", c0sid:"S0004105", c0text: "LIONBAR HELSINGBORG", c0typ: "", unit: "lion0005", c0avd: "01"},
                { c0lopnr:"6", c0sid:"S0004106", c0text: "LIONBAR SKELLEFTEÅ", c0typ: "", unit: "lion0006", c0avd: "01"},
                { c0lopnr:"7", c0sid:"S0004107", c0text: "LIONBAR VÄSTERÅS", c0typ: "", unit: "lion0007", c0avd: "01"},
                { c0lopnr:"8", c0sid:"S0004201", c0text: "GERMAN VISBY", c0typ: "", unit: "german01", c0avd: "01"},
                { c0lopnr:"9", c0sid:"S0004202", c0text: "GERMAN NORRTULL", c0typ: "", unit: "german02", c0avd: "01"},
                { c0lopnr:"10", c0sid:"S0004203", c0text: "GERMAN KUNGSHOLMEN", c0typ: "", unit: "german03", c0avd: "01"},
            ];
            //this.setState({ csa: csa });
            sso.sdo.csa = csa;
        }
        if(sso.seo.csid == "0031") {
            csa = [
                //{ id:"0", typ:"0", text: "INGET CENTRALSYSTEM"},
                { c0lopnr:"1", c0sid:"S0002497", c0text: "AMICE KARLSTAD", c0typ: "", unit: "barj0001", c0avd: "01"},
                { c0lopnr:"2", c0sid:"S0002498", c0text: "AMICE ÖREBRO", c0typ: "", unit: "barj0002", c0avd: "01"},
                { c0lopnr:"3", c0sid:"S0002607", c0text: "AMICE NYKÖPING", c0typ: "", unit: "barj0003", c0avd: "01"},
                { c0lopnr:"4", c0sid:"S0002482", c0text: "FROST KARLSTAD", c0typ: "", unit: "barj0004", c0avd: "01"},
                //{ c0lopnr:"5", c0sid:"S0002463", c0text: "CHOW CHASE KARLSTAD", c0typ: "", unit: "barj0005", c0avd: "01"},
                { c0lopnr:"6", c0sid:"S0003121", c0text: "BRASSERIET KARLSTAD", c0typ: "", unit: "barj0006", c0avd: "01"},
                { c0lopnr:"7", c0sid:"S0002462", c0text: "PITCHERS ÖREBRO", c0typ: "", unit: "barj0007", c0avd: "01"},
                { c0lopnr:"8", c0sid:"S0002496", c0text: "PITCHERS ÄNGELHOLM", c0typ: "", unit: "barj0008", c0avd: "01"},
                { c0lopnr:"9", c0sid:"S0002492", c0text: "PITCHERS LINKÖPING", c0typ: "", unit: "barj0009", c0avd: "01"},
                { c0lopnr:"10", c0sid:"S0002461", c0text: "PITCHERS UPPSALA", c0typ: "", unit: "barj0010", c0avd: "01"},
            ];
            //this.setState({ csa: csa });
            sso.sdo.csa = csa;
        }
        //alert(JSON.stringify(sso.seo));
        //alert(JSON.stringify(sso.sdo));
    }

    header_css() {
  	    var css = {};
		if(this.state.top) {
			css.color = "#fff";
			css.background = "transparent";
			css.height = "50px";
			//css["background"] = "green";
		}
		else {
			css.color = "#000";
			css.background = "#fff";
		    css.height = "50px";
        }

		return css;
    }
    ham_mnu_css() {
  	    var css = {};
		if(this.state.top) {
			css.display = "flex";
			css.display = "none";
		}
		else {
			css.display = "none";
        }

		return css;
    }
    header_class() {
  	    var cls = "web-top";
		if(this.state.top) {
			//cls = cls + " web-head_1";
		}
		//else cls = cls +  " web-header";

		return cls;
    }

    sdo_upd() {
        var sdo = this.state.sdo;
        if(!sdo.fid) sdo.fid = "0";
        sdo.fid = ((sdo.fid * 1) + 1).toString();
        this.setState({sdo: sdo})
        sessionStorage.setItem("svp", JSON.stringify(this.state.sdo));
        //this.props.history.push("cas");
    }
    sdo_ctx() {
        sessionStorage.removeItem('svp');
        //sessionStorage.clear();
    }
    sdo_cas() {
        this.context.fid = "45";
        this.props.navigate("cas");
    }
    ct_show(id) {
        //alert(id);
        const element = document.getElementById(id);
        if (element) element.scrollIntoView();
        //const tesNode = ReactDOM.findDOMNode(id);
        //window.scrollTo(0, tesNode.offsetTop);
    }
    w00_css() {
  	    var css = {};
        //css.height = window.innerHeight;
        //css['minHeight'] = window.innerHeight;
		return css;
    }
    mnu_sel(mnuid) {

        this.setState({mnu_sel: mnuid});
        const element = document.getElementById(mnuid);
        if (element) element.scrollIntoView();
    }

   mnu_item_css(mnuid) {
  	    var css = {};

        if(this.state.mnu_sel == mnuid) {
			///css.background = "#080";
			//css.color = "#fff";
			css.color = "#080";
        }
		return css;
    }
    row_css(row) {
  	    var css = {};
		if(this.state.row) {
		if(this.state.row.ank == row.ank) {
			css.background = "#080";
			css.color = "#fff";
		}
		}
		return css;
    }
    login() {
        this.setState({login: true });
        //this.props.history.push("pos");
    }
    row_icon_css(id, op) {
            var css = {};
            if(id == op) {
                css.background = "#080";
                css.color = "#fff";
            }
        //css.paddingTop = "5px";
        css.fontSize = "20px";
		return css;
    }

    fknGo(url) {
        this.props.navigate(url);
   };
    logout() {
        this.props.navigate("/");
   };
  mnu_style(id, op) {
      var css = {};
      if(id == op) {
          css.background = "#080";
          css.color = "#fff";
      }
      return css;
  }
    sel_fkn(sel) {
        //alert(JSON.stringify(sel.fkn));
        if(sel.fkn == "logout") {
            var url = "/logout";
            this.props.navigate(url);
        }
        if(sel.fkn == "refresh") {
            window.location.reload(true);
        }
    }

    render() {
      var mnus = ["day", "oms", "dash", "stat"];
      var path = window.location.pathname;
      var op = path.split("/").pop();
      if( !mnus.includes(op) ) op = "home";

        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
        const handleDateChange = date => {
            this.setState({seldate: date });
        };

        return (
            <div className="web-app">
            <div id="header" className={ this.header_class() }>
            <div className="web-top-content d-flex flex-row">
                <div className="web-mnu-bars hide">
                    <i className="fa fa-bars flex" aria-hidden="true" style={{padding: "10px"}}></i>
                </div>
                <div className="flex-row txt_18">
                    SPAIDER
                </div>
                <div className="flex-fill">
                </div>

                <div className="web-top-usr d-flex flex-column">
                    <div><FontAwesomeIcon icon="user" size="1x"/> { sso.seo.name }</div>
                    <div><FontAwesomeIcon icon="envelope" size="1x"/> { sso.seo.mbox }</div>
                </div>
                <div className="">
                    <Dd_Sel items={ this.state.mnuitems } cls="web-top-icon" getValue={(e)=> this.sel_fkn(e)} />
                </div>
            </div>
            </div>

            <div className="flex">

                <Routes>
                <Route path="dash/*" forceRefresh={true} element={ <CcsDash store={this.webStore} />} />
                <Route path="day/*" forceRefresh={true} element={ <CcsDay store={this.webStore} />} />
                <Route path="pt/*" forceRefresh={true} element={ <CcsPt store={this.webStore} />} />
                <Route path="oms/*" forceRefresh={true} element={ <CcsOms store={this.webStore} />} />
                <Route path="per/*" forceRefresh={true} element={ <CcsPer store={this.webStore} />} />
                <Route path="stat/*" forceRefresh={true} element={ <CcsStat store={this.webStore} />} />
                <Route path="trs/*" forceRefresh={true} element={ <CcsTrs store={this.webStore} />} />
                    <Route path="vgrp/*" forceRefresh={true} element={ <CcsVgrp store={this.webStore} />} />
                    <Route path="th/*" forceRefresh={true} element={ <CcsMsg store={this.webStore} />} />
                    <Route path="menu/*" forceRefresh={true} element={ <CcsMsg store={this.webStore} />} />
                    <Route path="*" forceRefresh={true} element={ <CcsHome store={this.webStore} />} />
                </Routes>

            </div>

                <div className="web-foot">
                    <div className="flex-row">
                        <div className="foot-btn flex-col ripple" style={ this.mnu_style("home", op) } onClick={() => this.fknGo("/csc/")}>
                            <FontAwesomeIcon icon="home" size="lg" color="grey" style={ this.row_icon_css("home", op) } />
                            <div style={{fontSize: "12px"}}>HEM</div>
                        </div>
                        <div className="foot-btn flex-col ripple" style={ this.mnu_style("day", op) } onClick={() => this.fknGo("/csc/day")}>
                            <FontAwesomeIcon icon="dashboard" size="lg" color="grey" style={ this.row_icon_css("day", op) } />
                            <div style={{fontSize: "12px"}}>STATUS</div>
                        </div>
                        <div className="foot-btn flex-col ripple" style={ this.mnu_style("oms", op) } onClick={() => this.fknGo("/csc/oms")}>
                            <FontAwesomeIcon icon="books" size="lg" color="grey" style={ this.row_icon_css("oms", op) } />
                            <div style={{fontSize: "12px"}}>PERIOD</div>
                        </div>
                        <div className="foot-btn flex-col ripple" style={ this.mnu_style("dash", op) } onClick={() => this.fknGo("/csc/dash")}>
                            <FontAwesomeIcon icon="list-alt" size="lg" color="grey" style={ this.row_icon_css("dash", op) } />
                            <div style={{fontSize: "12px"}}>ÖVERSIKT</div>
                        </div>
                        <div className="foot-btn flex-col ripple" style={ this.mnu_style("stat", op) } onClick={() => this.fknGo("/csc/stat")}>
                            <FontAwesomeIcon icon="list" size="lg" color="grey" style={ this.row_icon_css("stat", op) } />
                            <div style={{fontSize: "12px"}}>STATISTIK</div>
                        </div>
                    </div>
                </div>
         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default withRouter(Csc);
